import Cookies from 'js-cookie';
import { clearUnifiedAuth } from '@/features/cmhub/session';
import { clearCmhubResources } from '@/features/cmhub/resources';

const ULStorageKey = {
  curEnv: 'curEnv',
  token: 'token',
  name: 'name',
  userInfo: 'user_info',
  appId: 'appId',
  accountId: 'accountId',
  isolatedId: 'isolatedId',
  znEnv: 'znEnv',
  tenantId: 'tenantId',
  tenantCode: 'tenantCode',
  phone: 'phone',
  pwdStatus: 'pwdStatus',
  method: 'method',
};

const clearApaasLayoutCache = () => {
  try {
    localStorage.removeItem('columns');
    localStorage.removeItem('serverRouter');
    localStorage.removeItem('routeCache');
    console.log('Apaas布局缓存清理成功');
  } catch (err) {
    console.log('%c [ err ]', 'font-size:20px; background:pink; color:#bf2c9f;', err);
  }
};

const rmToken = () => {
  clearCmhubResources();
  clearUnifiedAuth();
  Object.values(ULStorageKey).forEach((key) => {
    if (key !== 'curEnv' && key !== 'appId' && key !== 'znEnv') localStorage.setItem(key, '');
  });
  localStorage.removeItem('elements');
  localStorage.removeItem('routeCache');
  localStorage.removeItem('workflow_add');
  localStorage.removeItem('workflow_edit');

  Cookies.remove('zn_env');
  clearApaasLayoutCache();
};

export {
  ULStorageKey,
  rmToken,
};
